import { useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { useUiStore } from '@/stores/ui';
import { t } from '@/i18n';

/** Persistent strip shown whenever the browser reports no connection. */
export function OfflineBanner() {
  const online = useUiStore((s) => s.online);
  const setOnline = useUiStore((s) => s.setOnline);

  useEffect(() => {
    const up = (): void => setOnline(true);
    const down = (): void => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, [setOnline]);

  if (online) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-warning-bg px-4 py-1.5 text-sm font-semibold text-text"
    >
      <WifiOff size={16} aria-hidden />
      {t('error.offline')}
    </div>
  );
}
